var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconEloDebit = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlSpace: "preserve",
  id: "Layer_1",
  x: 0,
  y: 0,
  style: {
    enableBackground: "new 0 0 257.5 157"
  },
  viewBox: "0 0 257.5 157",
  ref: svgRef
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
  d: "M32.5 146.3h193.1c2.8 0 5.1-2.3 5.1-5.1V14.7c0-2.8-2.3-5.1-5.1-5.1H32.5c-2.8 0-5.1 2.3-5.1 5.1v126.5c0 2.8 2.3 5.1 5.1 5.1z",
  style: {
    stroke: "#000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M81.3 63.1c1.6-.5 3.2-.8 5-.8 7.6 0 13.9 5.4 15.4 12.5l10.7-2.2c-2.5-12.2-13.2-21.3-26.1-21.3-3 0-5.8.5-8.4 1.4l3.4 10.4zM68.6 97.9l7.3-8.2c-3.2-2.9-5.3-7.1-5.3-11.7 0-4.7 2-8.9 5.3-11.7L68.6 58c-5.5 4.9-9 12-9 19.9 0 8 3.5 15.1 9 20M101.6 81.1c-1.4 7.1-7.8 12.5-15.3 12.5-1.7 0-3.4-.3-5-.8l-3.5 10.4c2.7.9 5.5 1.4 8.4 1.4 12.9 0 23.6-9.1 26.1-21.3l-10.7-2.2zM121.7 90c-.4-.6-.8-1.5-1.1-2.2-1.7-3.9-1.8-8-.3-12 1.6-4.3 4.6-7.6 8.5-9.3 4.9-2.1 10.3-1.7 15 1.1 3 1.7 5.1 4.3 6.7 8.1.2.5.4 1 .6 1.4L121.7 90zm9.8-17c-3.5 1.5-5.3 4.8-4.9 8.6l14.7-6.3c-2.5-3-5.8-4-9.8-2.3zm11.7 13.8-.3-.2c-.9 1.4-2.2 2.6-4 3.3-3.3 1.4-6.3 1.1-8.5-.9l-.2.3-3.7 5.6c.9.6 1.9 1.2 3 1.6 4.1 1.7 8.4 1.6 12.5-.2 3-1.3 5.4-3.3 7-5.8l-5.8-3.7zm18.1-28.4v31.1l4.8 2-2.7 6.4-5.3-2.2c-1.2-.5-2-1.3-2.6-2.2-.6-.9-1-2.2-1-3.8V58.4h6.8zm12.5 23.2c0-2.6 1.2-5 3-6.6l-5-5.5c-3.4 3-5.5 7.3-5.5 12.2 0 4.8 2.1 9.2 5.5 12.2l5-5.5c-1.9-1.8-3-4.1-3-6.8zm8.8 8.8c-1 0-1.9-.2-2.8-.5l-2.4 7c1.6.5 3.3.8 5.2.8 7.9 0 14.4-5.6 15.9-13l-7.3-1.5c-.8 4.2-4.3 7.2-8.6 7.2zm0-25c-1.8 0-3.5.3-5.1.8l2.3 7c.9-.3 1.8-.4 2.8-.4 4.3 0 7.8 3 8.6 7.1l7.3-1.5c-1.5-7.4-8-13-15.9-13z",
  className: "st2"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEloDebit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconEloDebit.4c187f62.svg";
export { ForwardRef as ReactComponent };